import { useEffect } from 'react'

const GoogleTagManager = () => {
  useEffect(() => {
    if (import.meta.env.MODE !== 'production') return

    // Load GA / GAds script
    const gtagScript = document.createElement('script')
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-2PTY4PG5TB'
    gtagScript.async = true
    document.head.appendChild(gtagScript)

    // Inline config script
    const script = document.createElement('script')
    script.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-2PTY4PG5TB');
      gtag('config', 'AW-370292220');
      gtag('event', 'conversion', {'send_to': 'AW-370292220/20nvCL6Y6coYEPzryLAB'});
    `
    document.head.appendChild(script)
  }, [])

  return null
}

export default GoogleTagManager
